import { Component, OnInit } from '@angular/core';
import { EmopPublicWorkflowApprovalService } from '../../emop-public-workflow-approval.service';
import { EmopPublicWorkflowApprovalApiService } from '../../emop-public-workflow-approval-api.service';
import { EmopFormProClass } from '../../../../class/EmopFormProClass/EmopFormProClass';
import jwtDecode from 'jwt-decode';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-emop-public-workflow-approval-record',
  templateUrl: './emop-public-workflow-approval-record.component.html',
  styleUrls: ['./emop-public-workflow-approval-record.component.scss']
})
export class EmopPublicWorkflowApprovalRecordComponent implements OnInit {
  loading = true;
  constructor(
    public EmopPublicWorkflowApprovalService: EmopPublicWorkflowApprovalService,
    private EmopPublicWorkflowApprovalApiService: EmopPublicWorkflowApprovalApiService,
    private NzMessageService: NzMessageService
  ) { }

  ngOnInit(): void {
    this.EmopPublicWorkflowApprovalApiService.getTaskDetail(this.EmopPublicWorkflowApprovalService.processInstanceId).subscribe(async (rs) => {
      this.loading = false;
      this.EmopPublicWorkflowApprovalService.recordTable.data = rs.data.content;

      const assignee = jwtDecode(document.cookie)['additionalData'].additionalData.id;
      if (!this.EmopPublicWorkflowApprovalService.showForm) return;
      const res = await this.EmopPublicWorkflowApprovalApiService.firstTask(this.EmopPublicWorkflowApprovalService.processInstanceId, assignee).toPromise();
      if (!res.data) {
        console.error('该流程已被审批');
        this.NzMessageService.error('该流程节点已被审批');
        return;
      }
      this.EmopPublicWorkflowApprovalService.processNodeId = res.data.id;
      this.EmopPublicWorkflowApprovalApiService.getJsonSchema(res.data.id).subscribe((rs) => {
        let formData = [];
        const properties = JSON.parse(rs.data).properties;
        for (const key in properties) {
          let itemData = {
            mode: properties[key].ui?.widget || 'textarea',
            alias: properties[key].title,
            key
          };
          if (itemData.mode === 'radio') {
            itemData['options'] = properties[key].enum.map(item => {
              return {
                key: item,
                val: item
              };
            });
            itemData['value'] = itemData['options'][0]?.key;
          }
          formData.push(itemData);
        }
        this.EmopPublicWorkflowApprovalService.formData = new EmopFormProClass(formData);
        console.log(formData);
      });
    });
  }
}
